<template>
    <el-dialog 
        title="项目详情" 
        :visible.sync="dialogVisible" 
        width="900px" 
        :close-on-click-modal="false" 
        :append-to-body="true"
        @close="handleClose"
        class="project-detail-dialog"
    >
        <div class="project-detail" v-if="projectDetail">
            <!-- 基本信息 -->
            <div class="section-card">
                <div class="section-title">基本信息</div>
                <div class="section-content">
                    <div class="detail-row">
                        <div class="detail-item">
                            <span class="label">项目名称</span>
                            <span class="value">{{ projectDetail.projectName || '-' }}</span>
                        </div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-item half">
                            <span class="label">项目编号</span>
                            <span class="value">{{ projectDetail.projectCode || '-' }}</span>
                        </div>
                        <!-- <div class="detail-item half">
                            <span class="label">项目状态</span>
                            <span class="value">
                                <el-tag :type="projectDetail.status === 1 ? 'success' : 'info'" size="small">
                                    {{ getStatusText(projectDetail.status) }}
                                </el-tag>
                            </span>
                        </div> -->
                    </div>
                    <div class="detail-row">
                        <div class="detail-item half">
                            <span class="label">项目类型</span>
                            <span class="value">{{ getProjectTypeText(projectDetail.projectType) }}</span>
                        </div>
                        <div class="detail-item half">
                            <span class="label">采购类型</span>
                            <span class="value">{{ getProcurementTypeText(projectDetail.procurementType) }}</span>
                        </div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-item half">
                            <span class="label">行业</span>
                            <span class="value">{{ projectDetail.industryName || '-' }}</span>
                        </div>
                        <div class="detail-item half">
                            <span class="label">资格审查方式</span>
                            <span class="value">{{ getCredTypeText(projectDetail.credType) }}</span>
                        </div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-item">
                            <span class="label">推送媒介</span>
                            <div class="value tag-value" v-if="getPushPlatformList().length">
                                <el-tag
                                    v-for="item in getPushPlatformList()"
                                    :key="item.id || item.platformCode || item.platformName"
                                    size="small"
                                    type="info"
                                >{{ item.platformName }}</el-tag>
                            </div>
                            <span class="value" v-else>-</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 项目地址与资金 -->
            <div class="section-card">
                <div class="section-title">项目地址与资金</div>
                <div class="section-content">
                    <div class="detail-row">
                        <div class="detail-item">
                            <span class="label">项目所在地</span>
                            <span class="value">{{ getFullLocation() }}</span>
                        </div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-item half">
                            <span class="label">资金来源</span>
                            <span class="value">{{ getFundSourceText(projectDetail.fundSource) }}</span>
                        </div>
                        <div class="detail-item half">
                            <span class="label">招标组织形式</span>
                            <span class="value">{{ getTenderOrganizeFormText(projectDetail.tenderOrganizeForm) }}</span>
                        </div>
                    </div>
                    <div class="detail-row" v-if="projectDetail.procurementType === 2">
                        <div class="detail-item half">
                            <span class="label">采购组织形式</span>
                            <span class="value">{{ getPurchasingOrganizationFormText(projectDetail.purchasingOrganizationForm) }}</span>
                        </div>
                        <div class="detail-item half" v-if="projectDetail.preferentialPoliciesScope">
                            <span class="label">小微企业优惠幅度</span>
                            <span class="value">{{ projectDetail.preferentialPoliciesScope }}%</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 招标人信息 -->
            <div class="section-card">
                <div class="section-title">招标人信息</div>
                <div class="section-content">
                    <div class="detail-row">
                        <div class="detail-item half">
                            <span class="label">招标人名称</span>
                            <span class="value">{{ projectDetail.tendereeName || '-' }}</span>
                        </div>
                        <div class="detail-item half">
                            <span class="label">统一社会信用代码</span>
                            <span class="value">{{ projectDetail.tendereeCode || '-' }}</span>
                        </div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-item half">
                            <span class="label">联系人</span>
                            <span class="value">{{ projectDetail.tendereeContactPerson || '-' }}</span>
                        </div>
                        <div class="detail-item half">
                            <span class="label">联系电话</span>
                            <span class="value">{{ projectDetail.tendereeContactPhone || '-' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 代理机构信息 -->
            <div class="section-card">
                <div class="section-title">代理机构信息</div>
                <div class="section-content">
                    <div class="detail-row">
                        <div class="detail-item half">
                            <span class="label">代理机构名称</span>
                            <span class="value">{{ projectDetail.agencyName || '-' }}</span>
                        </div>
                        <div class="detail-item half">
                            <span class="label">统一信用代码</span>
                            <span class="value">{{ projectDetail.agencyCode || '-' }}</span>
                        </div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-item half">
                            <span class="label">项目经理</span>
                            <span class="value">{{ projectDetail.agencyProjectManagerName || '-' }}</span>
                        </div>
                        <div class="detail-item half">
                            <span class="label">项目经理手机号</span>
                            <span class="value">{{ projectDetail.agencyProjectManagerPhone || '-' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 其他信息 -->
            <div class="section-card">
                <div class="section-title">其他信息</div>
                <div class="section-content">
                    <div class="detail-row">
                        <div class="detail-item half">
                            <span class="label">创建时间</span>
                            <span class="value">{{ projectDetail.createTime || '-' }}</span>
                        </div>
                        <div class="detail-item half">
                            <span class="label">修改时间</span>
                            <span class="value">{{ projectDetail.modifyTime || '-' }}</span>
                        </div>
                    </div>
                    <div class="detail-row" v-if="projectDetail.remark">
                        <div class="detail-item">
                            <span class="label">备注</span>
                            <span class="value">{{ projectDetail.remark }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 附件信息 -->
            <div class="section-card" >
                <div class="section-title">附件信息</div>
                <div class="section-content">
                    <el-table :data="attachmentList" border stripe style="width: 100%">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="fileName" label="文件名称" min-width="200" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="fileExtension" label="文件类型" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag size="small" type="info">{{ scope.row.fileExtension || '-' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="fileSize" label="文件大小" width="120" align="center">
                            <template slot-scope="scope">
                                {{ formatFileSize(scope.row.fileSize) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="handleDownload(scope.row)">
                                    <i class="el-icon-download"></i> 下载
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose" size="medium">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { getFileList } from '@/api/base/api'

export default {
    name: 'ProjectDetailDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        projectDetail: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            attachmentList: [],
            loadingAttachments: false
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val)
            }
        }
    },
    watch: {
        projectDetail: {
            handler(newVal) {
                if (newVal && newVal.fileGuid) {          
                    this.getAttachmentList(newVal.fileGuid)
                } else {
                    this.attachmentList = []
                }
            },
            immediate: true
        }
    },
    methods: {
        handleClose() {
            this.$emit('update:visible', false)
            this.$emit('close')
        },

        // 获取完整地址
        getFullLocation() {
            const { projectLocationProvince, projectLocationCity, projectLocation } = this.projectDetail
            const parts = [projectLocationProvince, projectLocationCity, projectLocation].filter(Boolean)
            return parts.length > 0 ? parts.join(' ') : '-'
        },

        // 项目状态
        getStatusText(status) {
            return status === 1 ? '已提交' : '暂存'
        },

        // 项目类型
        getProjectTypeText(type) {
            const typeMap = {
                '01': '公开招标',
                '02': '竞争性谈判',
                '03': '竞争性磋商',
                '04': '邀请招标',
                '05': '询价',
                '06': '单一来源'
            }
            return typeMap[type] || '-'
        },

        // 采购类型
        getProcurementTypeText(type) {
            const typeMap = {
                1: '企业采购',
                2: '政府采购',
                3: '建设工程'
            }
            return typeMap[type] || '-'
        },

        // 资格审查方式
        getCredTypeText(type) {
            return type === 1 ? '资格预审' : '资格后审'
        },

        // 资金来源
        getFundSourceText(source) {
            const sourceMap = {
                '1': '政府投资',
                '2': '企业自筹',
                '9': '其他'
            }
            return sourceMap[source] || '-'
        },

        // 招标组织形式
        getTenderOrganizeFormText(form) {
            const formMap = {
                1: '自行招标',
                2: '委托招标'
            }
            return formMap[form] || '-'
        },

        // 采购组织形式
        getPurchasingOrganizationFormText(form) {
            const formMap = {
                1: '集中采购',
                2: '分散采购',
                9: '其他'
            }
            return formMap[form] || '-'
        },

        // 是否类型转换
        getYesNoText(value) {
            if (value === null || value === undefined) return '-'
            return value === 1 ? '是' : '否'
        },

        getPushPlatformList() {
            const list = this.projectDetail && Array.isArray(this.projectDetail.pushPlatformList)
                ? this.projectDetail.pushPlatformList
                : []
            return list.filter(item => item && item.platformName)
        },

        // 获取附件列表
        async getAttachmentList(fileGuid) {
            if (!fileGuid) {
                this.attachmentList = []
                return
            }
            this.loadingAttachments = true
            try {
                const res = await getFileList(fileGuid)
                if (res.code === 200 && res.data) {
                    this.attachmentList = res.data
                } else {
                    this.attachmentList = []
                }
            } catch (error) {
                console.error('获取附件列表失败:', error)
                this.attachmentList = []
            } finally {
                this.loadingAttachments = false
            }
        },

        // 格式化文件大小
        formatFileSize(bytes) {
            if (!bytes || bytes === 0) return '-'
            const k = 1024
            const sizes = ['B', 'KB', 'MB', 'GB']
            const i = Math.floor(Math.log(bytes) / Math.log(k))
            return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i]
        },

        // 下载文件
        handleDownload(file) {
            if (file.fileUrl) {
                window.open(file.fileUrl, '_blank')
            } else {
                this.$message.warning('文件下载链接不存在')
            }
        }
    }
}
</script>

<style lang="less" scoped>
.project-detail {
    .section-card {
        background: #fff;
        border-radius: 4px;
        margin-bottom: 16px;
        
        &:last-child {
            margin-bottom: 0;
        }
    }
    
    .section-title {
        padding: 12px 16px;
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        background: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;
    }
    
    .section-content {
        padding: 16px;
    }
    
    .detail-row {
        display: flex;
        margin-bottom: 12px;
        
        &:last-child {
            margin-bottom: 0;
        }
    }
    
    .detail-item {
        flex: 1;
        display: flex;
        align-items: baseline;
        padding: 8px 0;
        
        &.half {
            flex: 0 0 50%;
            padding-right: 16px;
        }
        
        .label {
            min-width: 140px;
            color: #606266;
            font-size: 14px;
            flex-shrink: 0;
            margin-right: 12px;
        }
        
        .value {
            color: #303133;
            font-size: 14px;
            word-break: break-all;
            flex: 1;
        }

        .tag-value {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px;
            word-break: break-word;
        }
    }
}

:deep(.el-dialog) {
    border-radius: 4px;
    
    .el-dialog__header {
        padding: 16px 20px;
        border-bottom: 1px solid #e4e7ed;
        
        .el-dialog__title {
            font-size: 16px;
            font-weight: 600;
            color: #303133;
        }
    }
    
    .el-dialog__body {
        padding: 0;
        max-height: 65vh;
        overflow-y: auto;
        background: #f5f7fa;
    }
    
    .el-dialog__footer {
        padding: 12px 20px;
        border-top: 1px solid #e4e7ed;
        text-align: right;
    }
}

@media (max-width: 768px) {
    :deep(.el-dialog) {
        width: 95% !important;
    }
    
    .project-detail {
        .detail-row {
            flex-direction: column;
        }
        
        .detail-item {
            &.half {
                flex: 1;
                padding-right: 0;
            }
        }
    }
}
</style>
